import { ABILITY_EFFECT_DATABASE } from '../../../../shared/content/generated/ability-effects.gen';
import type { VFXEffectConfig } from '../../VFXEffectRegistry';
import { glintScatter, ringBlast } from './burstBuilders';

const HEALTH_POTION_BURST: VFXEffectConfig = {
  id: 'consumable_health_burst',
  name: 'Health Potion Use',
  category: 'burst',
  description: 'Immediate red life ring and rising restorative glints',
  primitives: [
    ringBlast({ color: 0xEF4444, radius: 18, expandTo: 2.1, durationMs: 420 }),
    glintScatter({ color: 0xFCA5A5, count: 5, spread: 28, durationMs: 520 }),
  ],
};

const MANA_POTION_BURST: VFXEffectConfig = {
  id: 'consumable_mana_burst',
  name: 'Mana Potion Use',
  category: 'burst',
  description: 'Immediate blue arcane ring and mana glints',
  primitives: [
    ringBlast({ color: 0x3B82F6, radius: 17, expandTo: 2.2, durationMs: 460 }),
    glintScatter({ color: 0x93C5FD, count: 6, spread: 30, durationMs: 560 }),
  ],
};

const BUFF_CONSUMABLE_BURST: VFXEffectConfig = {
  id: 'consumable_buff_burst',
  name: 'Buff Consumable Use',
  category: 'burst',
  description: 'Gold activation ring before the persistent aura takes over',
  primitives: [
    ringBlast({ color: 0xFACC15, radius: 20, expandTo: 2.4, durationMs: 500 }),
    glintScatter({ color: 0xFEF08A, count: 7, spread: 34, durationMs: 620 }),
  ],
};

const DISPEL_CONSUMABLE_BURST: VFXEffectConfig = {
  id: 'consumable_dispel_burst',
  name: 'Antidote Use',
  category: 'burst',
  description: 'Clean white-green purge expanding off the consumer',
  primitives: [
    ringBlast({ color: 0x22C55E, radius: 16, expandTo: 2.6, durationMs: 380 }),
    glintScatter({ color: 0xF0FDF4, count: 8, spread: 36, durationMs: 480 }),
  ],
};

export const CONSUMABLE_VFX: VFXEffectConfig[] = [
  HEALTH_POTION_BURST,
  MANA_POTION_BURST,
  BUFF_CONSUMABLE_BURST,
  DISPEL_CONSUMABLE_BURST,
];

export function resolveConsumableUseVfx(effectIds: readonly string[]): string {
  const effects = effectIds
    .map(effectId => ABILITY_EFFECT_DATABASE[effectId])
    .filter(Boolean);
  if (effects.some(effect => effect.effectType === 'dispel')) return 'consumable_dispel_burst';
  if (effects.some(effect => effect.effectType === 'buff')) return 'consumable_buff_burst';
  if (effects.some(effect =>
    (effect.effectType === 'heal' || effect.effectType === 'hot')
      && effect.restoreResource === 'mana'
  )) return 'consumable_mana_burst';
  return 'consumable_health_burst';
}
